module.exports = __webpack_public_path__ + "static/media/food-truck-line-share.6eba9d45.png";